<template>
  <header>
    <div class="navbar">
      <RouterLink to="/" class="logo">
        <img src="https://www.ouicsport.fr/images/site-logo.png" alt="OuiCSport">
      </RouterLink>
      <div class="menu-hamburger" @click="toggleMenu">☰</div>
      <nav>
        <ul v-show="isMenuVisible">
          <li><RouterLink to="/" class="li-nav" @click="closeMenu">Accueil</RouterLink></li>
          <li><RouterLink to="/OffersList" class="li-nav" @click="closeMenu">Activités</RouterLink></li>
          <li><RouterLink to="/Gallery" class="li-nav" @click="closeMenu">Galerie</RouterLink></li>
          <li><RouterLink to="/Contact" class="li-nav" @click="closeMenu">Contact</RouterLink></li>
          <li>
            <template v-if="!isLoggedIn">
              <RouterLink to="/login" class="login-button" @click="closeMenu">Se connecter</RouterLink>
            </template>
            <template v-else>
              <RouterLink to="/AccountPage" class="login-button" @click="closeMenu">Profil</RouterLink>
            </template>
          </li>
        </ul>
      </nav>
    </div>
    <div
      v-if="isNative && isMenuVisible"
      class="native-drawer-backdrop"
      @click="closeMenu"
    ></div>
  </header>
</template>


<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import jsonData from '@/assets/text.json';
import { isNative } from '@/api/base';


export default {
    name: 'AppHeader',
    data() {
    return {
      isMenuVisible: false,
    };
  },
    setup() {
        const store = useStore();
        const route = useRoute();
        const isHomePage = computed(() => route.path === '/');


        const isLoggedIn = computed(() => store.state.auth.user !== null);

        const editing = ref({
            welcome: false,
            title: false,
            subtitle: false,
            button: false
        });
        const texts = ref({});

        texts.value = jsonData;


        return { isLoggedIn, isHomePage, editing, texts, isNative };
    },
    methods: {
      toggleMenu() {
        if (window.innerWidth <= 768) {
          this.isMenuVisible = !this.isMenuVisible; 
        }
      },
      closeMenu() {
        if (window.innerWidth <= 768) {
          this.isMenuVisible = false; 
        }
      },
      checkScreenWidth() {
        this.isMenuVisible = window.innerWidth > 768;
      },
  },
  mounted() {
    this.checkScreenWidth(); 
    window.addEventListener('resize', this.checkScreenWidth); 
  },


}

</script>

<style>
/* Styles natifs (iOS / Android via Capacitor) — n'affectent JAMAIS le web. */
body.is-native header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  padding-top: env(safe-area-inset-top, 0);
  padding-left: env(safe-area-inset-left, 0);
  padding-right: env(safe-area-inset-right, 0);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  width: 100%;
}

body.is-native header .navbar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 6px 12px;
}

body.is-native header .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

body.is-native header .logo img {
  height: 44px;
  width: auto;
  max-width: 160px;
  display: block;
}

body.is-native header .menu-hamburger {
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  display: flex !important;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  font-size: 26px;
  line-height: 1;
  color: #dd4124;
  cursor: pointer;
  background: transparent;
  border: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

body.is-native header nav {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 78%;
  max-width: 320px;
  background: #ffffff;
  z-index: 1100;
  transform: translateX(-100%);
  transition: transform 0.28s ease;
  box-shadow: 2px 0 14px rgba(0, 0, 0, 0.18);
  padding-top: calc(env(safe-area-inset-top, 0) + 56px);
  padding-bottom: env(safe-area-inset-bottom, 0);
  padding-left: env(safe-area-inset-left, 0);
  overflow-y: auto;
}

body.is-native header nav ul {
  display: flex !important;
  flex-direction: column;
  align-items: stretch;
  list-style: none;
  margin: 0;
  padding: 8px 0;
}

body.is-native header nav ul li {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

body.is-native header nav ul li .li-nav,
body.is-native header nav ul li .login-button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 44px;
  padding: 12px 20px;
  font-family: 'Dosis', sans-serif;
  font-size: 16px;
  color: #222;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}

body.is-native header nav ul li .login-button {
  color: #dd4124;
  font-weight: 600;
  font-family: 'Gagalin', 'Dosis', sans-serif;
  letter-spacing: 0.5px;
}

body.is-native header nav ul li .router-link-exact-active {
  color: #dd4124;
}

/* Drawer ouvert : on s'appuie sur le v-show -> ul affiché => on translate la nav. */
body.is-native header nav:has(ul[style*="display: none"]) {
  transform: translateX(-100%);
}
body.is-native header nav:has(ul:not([style*="display: none"])) {
  transform: translateX(0);
}

body.is-native .native-drawer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1050;
  -webkit-tap-highlight-color: transparent;
}
</style>
